import * as Api from '@/helpers/restApi'

export default {
  state: {
    ShowAchievementsEditor: false,
    AchievementsData: []
  },
  getters: {
    getShowAchievementsEditor: state => state.ShowAchievementsEditor,
    getAchievementsData: state => state.AchievementsData
  },
  mutations: {
    SetShowAchievementsEditor (state, val) {
      state.ShowAchievementsEditor = val
    }
  },
  actions: {
    setAchievementsData ({ state, dispatch }) {
      Api.getApi({
        url: '/api/Achievements/GetAchievements'
      })
        .then((data) => {
          if (data.Succeeded) {
            state.AchievementsData = data.Data
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setChangeAchievementsData ({ state, dispatch }, val) {
      Api.putApi({
        url: '/api/Achievements/PutAchievements',
        payload: val
      })
        .then((data) => {
          if (!data.Succeeded) {
            dispatch('setShowErrorModal', data)
          }
        })
    }
  }
}
